import { Component } from '@angular/core';

@Component({
  selector: 'tech-core-quiz-divider',
  standalone: false,
  templateUrl: './divider.component.html',
  styleUrl: './divider.component.scss'
})
export class DividerComponent {

}
